import CancellationFees from '@ui/Accommodation/Details/Conditions/CancellationFees/component'
import Modification from '@ui/Accommodation/Details/Conditions/Modification/component'
import Payment from '@ui/Accommodation/Details/Conditions/Payment/component'

export default function (el: HTMLElement): void {
  const cancellationFees = el.querySelector<HTMLElement>('.accommodation-details-conditions-cancellation-fees')
  cancellationFees && CancellationFees(cancellationFees)

  const modification = el.querySelector<HTMLElement>('.accommodation-details-conditions-modification')
  modification && Modification(modification)

  const payment = el.querySelector<HTMLElement>('.accommodation-details-conditions-payment')
  payment && Payment(payment)
}
